import React from 'react';
import GenericErrorUI from '../../../components/common/GenericErrorUI';
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI';
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI';
import IconButtonUI from '../../../widgets/action/IconButtonUI';
import EmptyListUI from '../../../widgets/output/EmptyListUI';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI';
import CardUI from '../../../widgets/layout/CardUI';
import SalesChartUI from '../../../components/superUser/account/SalesChartUI';
import SelectUI from '../../../widgets/input/SelectUI';
import SalesTargetNavUI from './SalesTargetNavUI';

const SalesChartPageUI = ({ context, errorList, salesTargetList,
  salesChannelList, userIdList, monthList, yearList, selectedTarget,
  month, onMonthChange, channel, onChannelChange, originator, onOriginatorChange,
  onFilterChange, filteredSalesTargetList, onDownloadClick, userIdSList,
  onRefreshClick, dataKeys, selectLine, monthWiseData, channelWiseData, originatorWiseData,
  filter, filterList
}) =>

(

  <SuperUserHomePageUI
    context={context} className='pg_su_ld' topnav='accounts' dimension='w1600'
    centered={!filteredSalesTargetList && !errorList} page='salesTargets'
  >
    {
      (!filteredSalesTargetList && !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {filteredSalesTargetList && filteredSalesTargetList.length > 0 &&
      <LRTableActionsUI
        location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <span className='g_m_left_100 g_large'><b>Charts</b></span>
          </span>
        }
        right={
          <span className='g_flex_h'>
            <div className='g_m_right_100 g_m_top_100' style={{ width: '200px' }}>
              <SelectUI
                selectedKey={filter}  // Changed from selectedKey to value
                optionList={filterList}
                onChange={onFilterChange}
                placeholder="Select View"
              />
            </div>
          </span>
        }
      />
    }
    {filteredSalesTargetList &&<SalesTargetNavUI page='chart' />}
    {
      filteredSalesTargetList && filteredSalesTargetList.length === 0 && (
        <EmptyListUI context={context} createEnabled={false} createDisabledMessageLabel='No data' />
      )
    }
    {
      filteredSalesTargetList && filteredSalesTargetList.length > 0 && (
        <SalesChartUI
          context={context}
          salesTargetList={filteredSalesTargetList}
          salesChannelList={salesChannelList}
          monthList={monthList}
          dataKeys={dataKeys}
          selectLine={selectLine}
          monthWiseData={monthWiseData}
          channelWiseData={channelWiseData}
          originatorWiseData={originatorWiseData}
          filter={filter}
          filterList={filterList}
          onFilterChange={onFilterChange}
        />
      )
    }

  </SuperUserHomePageUI>
);

export default SalesChartPageUI;
